import { useState } from 'react';
import {
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Button,
  Box,
  Divider,
  Paper,
  Avatar,
  useTheme
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { fetchProductListDataStore } from '../../../../Reducer/dataAdminSlice';

export default function EditButtonWithPopup({ product }) {
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(product?.exhibitors_count || '');
  const dispatch = useDispatch();
  const theme = useTheme();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleUpdate = async () => {
    try {
      await axios.put(`/api/v1/update-product-record/${product.id}`, { exhibitors_count: count });
      toast.success('Count updated successfully');
      dispatch(fetchProductListDataStore({ page: 1, limit: 10, event_name: '' }));
      handleClose();
    } catch (error) {
      toast.error('Failed to update count');
      console.error('Update error:', error);
    }
  };

  return (
    <>
      <Tooltip title="Edit Count" arrow>
        <IconButton 
          color="primary" 
          onClick={handleOpen}
          sx={{
            backgroundColor: 'white',
            '&:hover': {
              backgroundColor: theme.palette.primary.main,
            }
          }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Dialog 
        open={open} 
        onClose={handleClose} 
        fullWidth 
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: theme.shadows[10]
          }
        }}
      >
        <Paper elevation={0} sx={{ p: 2, bgcolor: theme.palette.primary.main }}>
          <DialogTitle sx={{ p: 0 }}>
            <Box display="flex" alignItems="center" gap={2}>
              <Avatar sx={{ bgcolor: 'white', color: theme.palette.primary.main }}>
                <EditIcon />
              </Avatar>
              <Typography variant="h6" color="white" fontWeight={600}>
                Update Exhibitor Count
              </Typography>
            </Box>
          </DialogTitle>
        </Paper>
        
        <Divider />
        
        <DialogContent sx={{ py: 3 }}>
          <Box 
            mb={3} 
            p={2} 
            borderRadius={2} 
            bgcolor={theme.palette.grey[100]}
            boxShadow={theme.shadows[1]}
          >
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Event Information
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {product.event_name}
            </Typography>
          </Box>
          
          <TextField
            label="Exhibitor Count"
            type="number"
            fullWidth
            variant="outlined"
            value={count}
            onChange={(e) => setCount(e.target.value)}
            margin="normal"
            inputProps={{ min: 0 }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                '&.Mui-focused fieldset': {
                  borderColor: theme.palette.primary.main,
                },
              },
            }}
          />
        </DialogContent>
        
        <Divider />
        
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button 
            onClick={handleClose} 
            color="primary" 
            variant="outlined"
            sx={{
              borderRadius: 2,
              px: 3,
              textTransform: 'none',
              '&:hover': {
                backgroundColor: theme.palette.grey[100]
              }
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleUpdate} 
            color="primary" 
            variant="contained"
            sx={{
              borderRadius: 2,
              px: 3,
              textTransform: 'none',
              boxShadow: 'none',
              '&:hover': {
                boxShadow: 'none',
                backgroundColor: theme.palette.primary.dark
              }
            }}
          >
            Update Count
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}